import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";
import { useTableParams } from "utils/hooks/common/useTableParams";
import ProductCategoryActions from "./components/ProductCategoryActions/ProductCategoryActions";
import ProductCategoryTable from "./components/ProductCategoryTable/ProductCategoryTable";

const ProductCategoryWebLayout: FC = () => {
  const { params, handlePageChange, handleLimitChange, handleSearch } =
    useTableParams();

  return (
    <Stack gap="sm">
      <PageHeader
        breadcrumbs={[{ title: "Quản lý Nhóm mặt hàng", href: "" }]}
      />
      <PageContent>
        <Stack gap="xs">
          <ProductCategoryActions handleSearch={handleSearch} params={params} />
          <ProductCategoryTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default ProductCategoryWebLayout;
